<template>
    <div v-if="config.display" :style="{'width': config.width || '100%'}" :class="cssClass" v-bind="config" :data-test-id="dataTestId" v-html="value ? ddStoreFilter(value) : ddStoreFilter(config.text)"></div>
</template>

<script>
import { controlMixins } from "./controlMixins.js";

let editorSettings = {};

export const alertComponent = {
    editorSettings: editorSettings,
    mixins: [controlMixins],
    computed: {
        cssClass: function () {
            let config = this.config;
            let type = 'primary';
            if (config) {
                switch (config.type) {
                    case 'warning':
                        type = 'warning';
                        break;
                    case 'error':
                        type = 'danger';
                        break;
                    case 'success':
                        type = 'success';
                        break;
                }
            }
            let cssClass = 'alert alert-' + type + ' ac mt20 ';
            if (config) cssClass += config.cssClass;

            return cssClass;
        }
    }
};

export default alertComponent;
</script>

<style>
    .alert {
        padding: 10px;
        background: white;
        border: 1px solid #777;
        border-radius: 3px;
        line-height: 1.4;
        margin-bottom: 10px;
    }
    .alert.alert-danger {
        background: #f1c2c2;
        color: #491010;
        border-color: #b65a5a;
    }
    .alert.alert-primary {
        background: #c8e0ee;
        color: #0a223b;
        border-color: #738dd0;
    }
    .alert.alert-success {
        color: #3c763d;
        background-color: #dff0d8;
        border-color: #d6e9c6;
    }
</style>
